{
  "_comment": "Product tour step registry. Keys are route prefixes; the longest matching prefix wins. Each step targets a [data-tour=\"...\"] element and references i18n keys for the title/description. Edit this file to tweak the 'How To' walkthrough for any page.",
  "/": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.dashboard.header.title",
      "descriptionKey": "tour.pages.dashboard.header.description",
      "position": "bottom"
    },
    {
      "target": "topbar-store",
      "titleKey": "tour.steps.store.title",
      "descriptionKey": "tour.steps.store.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.dashboard.main.title",
      "descriptionKey": "tour.pages.dashboard.main.description",
      "position": "top"
    }
  ],
  "/customers": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.customers.header.title",
      "descriptionKey": "tour.pages.customers.header.description",
      "position": "bottom"
    },
    {
      "target": "topbar-search",
      "titleKey": "tour.steps.search.title",
      "descriptionKey": "tour.steps.search.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.customers.main.title",
      "descriptionKey": "tour.pages.customers.main.description",
      "position": "top"
    }
  ],
  "/vehicles": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.vehicles.header.title",
      "descriptionKey": "tour.pages.vehicles.header.description",
      "position": "bottom"
    },
    {
      "target": "topbar-search",
      "titleKey": "tour.steps.search.title",
      "descriptionKey": "tour.steps.search.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.vehicles.main.title",
      "descriptionKey": "tour.pages.vehicles.main.description",
      "position": "top"
    }
  ],
  "/jobs": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.jobs.header.title",
      "descriptionKey": "tour.pages.jobs.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.jobs.main.title",
      "descriptionKey": "tour.pages.jobs.main.description",
      "position": "top"
    }
  ],
  "/booking/new": [
    {
      "target": "newbooking-steps",
      "titleKey": "tour.steps.newBookingSteps.title",
      "descriptionKey": "tour.steps.newBookingSteps.description",
      "position": "bottom"
    },
    {
      "target": "newbooking-customer-tab",
      "titleKey": "tour.steps.newBookingCustomerTab.title",
      "descriptionKey": "tour.steps.newBookingCustomerTab.description",
      "position": "bottom"
    },
    {
      "target": "newbooking-services",
      "titleKey": "tour.steps.newBookingServices.title",
      "descriptionKey": "tour.steps.newBookingServices.description",
      "position": "top"
    },
    {
      "target": "newbooking-schedule",
      "titleKey": "tour.steps.newBookingSchedule.title",
      "descriptionKey": "tour.steps.newBookingSchedule.description",
      "position": "top"
    },
    {
      "target": "newbooking-rentcars",
      "titleKey": "tour.pages.newBooking.rentcars.title",
      "descriptionKey": "tour.pages.newBooking.rentcars.description",
      "position": "top"
    },
    {
      "target": "newbooking-confirm",
      "titleKey": "tour.steps.newBookingConfirm.title",
      "descriptionKey": "tour.steps.newBookingConfirm.description",
      "position": "top"
    },
    {
      "target": "newbooking-nav",
      "titleKey": "tour.steps.newBookingNav.title",
      "descriptionKey": "tour.steps.newBookingNav.description",
      "position": "top"
    }
  ],
  "/booking": [
    {
      "target": "booking-mode-toggle",
      "titleKey": "tour.steps.bookingModeToggle.title",
      "descriptionKey": "tour.steps.bookingModeToggle.description",
      "position": "bottom"
    },
    {
      "target": "booking-view-tabs",
      "titleKey": "tour.steps.bookingViewTabs.title",
      "descriptionKey": "tour.steps.bookingViewTabs.description",
      "position": "bottom"
    },
    {
      "target": "booking-nav-controls",
      "titleKey": "tour.steps.bookingNavControls.title",
      "descriptionKey": "tour.steps.bookingNavControls.description",
      "position": "bottom"
    },
    {
      "target": "booking-new-btn",
      "titleKey": "tour.steps.bookingNewBtn.title",
      "descriptionKey": "tour.steps.bookingNewBtn.description",
      "position": "left"
    },
    {
      "target": "day-time-header",
      "titleKey": "tour.steps.dayTimeHeader.title",
      "descriptionKey": "tour.steps.dayTimeHeader.description",
      "position": "bottom"
    },
    {
      "target": "day-vehicle-row",
      "titleKey": "tour.steps.dayVehicleRow.title",
      "descriptionKey": "tour.steps.dayVehicleRow.description",
      "position": "top"
    },
    {
      "target": "booking-drag-drop",
      "titleKey": "tour.steps.bookingDragDrop.title",
      "descriptionKey": "tour.steps.bookingDragDrop.description",
      "position": "top"
    }
  ],
  "/pricing": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.pricing.header.title",
      "descriptionKey": "tour.pages.pricing.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.pricing.main.title",
      "descriptionKey": "tour.pages.pricing.main.description",
      "position": "top"
    }
  ],
  "/my-workspace": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.myWorkspace.header.title",
      "descriptionKey": "tour.pages.myWorkspace.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.myWorkspace.main.title",
      "descriptionKey": "tour.pages.myWorkspace.main.description",
      "position": "top"
    }
  ],
  "/team-overview": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.teamOverview.header.title",
      "descriptionKey": "tour.pages.teamOverview.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.teamOverview.main.title",
      "descriptionKey": "tour.pages.teamOverview.main.description",
      "position": "top"
    }
  ],
  "/invoicing": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.invoicing.header.title",
      "descriptionKey": "tour.pages.invoicing.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.invoicing.main.title",
      "descriptionKey": "tour.pages.invoicing.main.description",
      "position": "top"
    }
  ],
  "/economy": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.economy.header.title",
      "descriptionKey": "tour.pages.economy.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.economy.main.title",
      "descriptionKey": "tour.pages.economy.main.description",
      "position": "top"
    }
  ],
  "/products": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.products.header.title",
      "descriptionKey": "tour.pages.products.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.products.main.title",
      "descriptionKey": "tour.pages.products.main.description",
      "position": "top"
    }
  ],
  "/rental-fleet": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.rentalFleet.header.title",
      "descriptionKey": "tour.pages.rentalFleet.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.rentalFleet.main.title",
      "descriptionKey": "tour.pages.rentalFleet.main.description",
      "position": "top"
    }
  ],
  "/campaigns": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.campaigns.header.title",
      "descriptionKey": "tour.pages.campaigns.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.campaigns.main.title",
      "descriptionKey": "tour.pages.campaigns.main.description",
      "position": "top"
    }
  ],
  "/account": [
    {
      "target": "topbar-user",
      "titleKey": "tour.steps.userMenu.title",
      "descriptionKey": "tour.steps.userMenu.description",
      "position": "bottom"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.account.header.title",
      "descriptionKey": "tour.pages.account.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.account.main.title",
      "descriptionKey": "tour.pages.account.main.description",
      "position": "top"
    }
  ],
  "/settings": [
    {
      "target": "sidebar-nav",
      "titleKey": "tour.steps.sidebarNav.title",
      "descriptionKey": "tour.steps.sidebarNav.description",
      "position": "right"
    },
    {
      "target": "topbar-title",
      "titleKey": "tour.pages.settings.header.title",
      "descriptionKey": "tour.pages.settings.header.description",
      "position": "bottom"
    },
    {
      "target": "main-content",
      "titleKey": "tour.pages.settings.main.title",
      "descriptionKey": "tour.pages.settings.main.description",
      "position": "top"
    }
  ]
}
